
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { usePrayerChoice } from '@/contexts/PrayerChoiceContext';

interface PrayCTAButtonProps {
  onPray: () => void;
  prayCount: number;
  prayer?: {
    id: string;
    title: string;
    content: string;
  };
}

export default function PrayCTAButton({ onPray, prayCount, prayer }: PrayCTAButtonProps) {
  const { openChoiceDialog } = usePrayerChoice();

  const handleClick = () => {
    if (prayer) {
      openChoiceDialog({
        id: prayer.id,
        title: prayer.title,
        content: prayer.content
      }, 'floating_action_bar');
    } else {
      onPray();
    }
  };

  return (
    <button
      onClick={handleClick}
      className="w-full inline-flex items-center justify-center gap-2 bg-black hover:bg-black/90 dark:bg-gold dark:hover:bg-gold/90 text-white dark:text-black font-semibold px-6 py-3 rounded-full transition-all duration-200 hover:scale-105 active:scale-95 shadow-sm hover:shadow-md"
    >
      <span>Let's Pray</span>
      <ArrowRight className="h-4 w-4" />
    </button>
  );
}
